/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Remove_Group_Confirm_TextInputs */



/**
* | output |
* | --- |
* | "Members stay on the team but lose access granted through this group." |
*
* @param {Team_Manager_Remove_Group_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_group_confirm_text = /** @type {((inputs?: Team_Manager_Remove_Group_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_Group_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les membres restent dans l'équipe mais perdent les accès accordés par ce groupe.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitglieder bleiben im Team, verlieren aber die über diese Gruppe gewährten Zugriffe.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I membri restano nel team ma perdono l'accesso concesso tramite questo gruppo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Участники останутся в команде, но потеряют доступ, выданный через эту группу.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los miembros siguen en el equipo, pero pierden el acceso concedido por este grupo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("成员仍保留在团队中，但会失去通过此群组获得的访问权限。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メンバーはチームに残りますが、このグループで付与されたアクセスは失われます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्य टीम में बने रहेंगे, लेकिन इस समूह से मिली पहुँच खो देंगे।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os membros continuam na equipa, mas perdem o acesso concedido por este grupo.")
	return /** @type {LocalizedString} */ ("Members stay on the team but lose access granted through this group.")
});